/**
 * @flow
 * @relayHash d2c64fd9d4192417c6cdbd2cf6f67b97
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type randomize_front_square_box_by_guest_mutationInput = {|
  guest_id: string,
  event_id: string,
  question_id: string,
  clientMutationId?: ?string,
|};
export type randomizeFrontSquareBoxByGuestMutationVariables = {|
  input: randomize_front_square_box_by_guest_mutationInput
|};
export type randomizeFrontSquareBoxByGuestMutationResponse = {|
  +randomizeFrontSquareBoxByGuest: ?{|
    +code: ?number,
    +message: ?string,
  |}
|};
export type randomizeFrontSquareBoxByGuestMutation = {|
  variables: randomizeFrontSquareBoxByGuestMutationVariables,
  response: randomizeFrontSquareBoxByGuestMutationResponse,
|};
*/


/*
mutation randomizeFrontSquareBoxByGuestMutation(
  $input: randomize_front_square_box_by_guest_mutationInput!
) {
  randomizeFrontSquareBoxByGuest(input: $input) {
    code
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "randomize_front_square_box_by_guest_mutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "randomizeFrontSquareBoxByGuest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "randomize_front_square_box_by_guest_mutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "randomizeFrontSquareBoxByGuestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "randomizeFrontSquareBoxByGuestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "randomizeFrontSquareBoxByGuestMutation",
    "id": null,
    "text": "mutation randomizeFrontSquareBoxByGuestMutation(\n  $input: randomize_front_square_box_by_guest_mutationInput!\n) {\n  randomizeFrontSquareBoxByGuest(input: $input) {\n    code\n    message\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ae04e34caa85787649ceb35361320252';
module.exports = node;
